module.exports = __webpack_public_path__ + "static/media/mobile_arrow_up.68dd6ee5.svg";